import {ResearchLitElement, html, css, unsafeHTML} from '@core/research-lit-element';

import './skeletons/research-filter-skeleton';
import './skeletons/research-pagination-skeleton';
import './skeletons/research-card-skeleton';

export class ResearchSkeleton extends ResearchLitElement {
    static get styles() {
        return css`
            :host {
                display: flex;
                --skeleton-border-radius: var(--border-radius) var(--border-radius) 0 0;
            }

            :host([no-padding]) {
                padding-top: 0;
            }

            @keyframes slide {
                0% {
                    transform: translateX(-100%);
                }
                50% {
                    transform: translateX(-100%);
                }
                100% {
                    transform: translateX(100%);
                }
            }

            div.skeleton {
                display: flex;
                flex-grow: 1;
                position: relative;
                overflow: hidden;
                z-index: 0;
                border-radius: var(--skeleton-border-radius);
            }

            div.skeleton:after {
                content: '';
                top: 0;
                bottom: 0;
                transform: translateX(100%);
                width: 100%;
                position: absolute;
                z-index: 1;
                animation: slide 3s infinite;
                background: linear-gradient(
                    to right,
                    rgba(255, 255, 255, 0) 0%,
                    rgba(255, 255, 255, var(--skeleton-opacity, 0.6)) 50%,
                    rgba(128, 186, 232, 0) 99%,
                    rgba(125, 185, 232, 0) 100%
                ); /* W3C */
            }
        `;
    }

    render() {
        return html`<div class="skeleton">${this._skeleton}</div>`;
    }

    static get properties() {
        return {
            component: {type: String},
            _skeleton: {type: String},
        };
    }

    connectedCallback() {
        super.connectedCallback();
        const element = `${this.component}`;
        this._skeleton = unsafeHTML(`<${element}></${element}>`);
    }
}
customElements.define('research-skeleton', ResearchSkeleton);
